import { render, staticRenderFns } from "./AirdropHistory.vue?vue&type=template&id=15e63bc2&scoped=true"
import script from "./AirdropHistory.vue?vue&type=script&lang=js"
export * from "./AirdropHistory.vue?vue&type=script&lang=js"
import style0 from "./AirdropHistory.vue?vue&type=style&index=0&id=15e63bc2&prod&lang=scss&scoped=true"
import style1 from "./AirdropHistory.vue?vue&type=style&index=1&id=15e63bc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e63bc2",
  null
  
)

export default component.exports